import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { toastr } from "react-redux-toastr";
import { hideModal } from '../../../actions/modal.actions';
import { loadBillingJobs, generateBillingJobInvoices } from '../../../actions/billingJobs.actions';
import { getModalData } from '../../../selectors/index';
import moment from "moment";

class BillingJobGenerateModal extends Component {

    state = {
        isSubmitting: false,
    }

    closeModal = () => {
        this.props.hideModal();
        if (this.props.modalProps.onCloseCallback) {
            this.props.modalProps.onCloseCallback();
        }
    }

    handleConfirm = () => {
        const { billingJob } = this.props.modalProps;
        this.setState({ isSubmitting: true });

        this.props.generateBillingJobInvoices(billingJob.id)
            .then(result => {
                if (result.success) {
                    toastr.success(`Invoices for Billing Job #${billingJob.id} are being generated.`, { timeOut: 3000, position: 'top-center' });
                    this.props.loadBillingJobs();
                    this.props.hideModal();
                } else {
                    const message = result.error?.message || result.error?.error || 'An unexpected error occurred.';
                    toastr.error('Generate Invoices Failed', message, { timeOut: 5000, position: 'top-center' });
                    this.setState({ isSubmitting: false });
                }
            });
    }

    render() {
        const { isSubmitting } = this.state;
        const { modalProps } = this.props;
        const billingJob = (modalProps && modalProps.billingJob) || {};

        return (
            <Fragment>
                <div className="modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Generate Invoices</h5>
                                <button onClick={this.closeModal} type="button" className="close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <p>
                                    You are about to generate invoices for billing job <strong>#{billingJob.id || 'N/A'}</strong> with
                                    invoice date <strong>{billingJob.invoiceDate ? moment(billingJob.invoiceDate).format('MM/DD/YYYY') : 'N/A'}</strong>.
                                </p>
                            </div>

                            <div className="modal-footer">
                                <button onClick={this.closeModal} className="btn btn-secondary" type="button">
                                    Cancel
                                </button>
                                <button onClick={this.handleConfirm} disabled={isSubmitting} className="btn btn-primary" type="button">
                                    Generate Invoices
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop show" tabIndex="1" />
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const modalProps = getModalData(state).modalProps;
    return {
        modalProps,
    };
};

const mapDispatchToProps = {
    hideModal,
    generateBillingJobInvoices,
    loadBillingJobs,
};

export default connect(mapStateToProps, mapDispatchToProps)(BillingJobGenerateModal);
